import React, { useEffect, useState, useRef } from "react";
import "./PLogin.scss";
import { Row, Col } from "react-bootstrap";
import * as Yup from "yup";
// import { FiUser } from "react-icons/fi";
// import { AiOutlineLock } from "react-icons/ai";
import Loginimage from "./Practice.webp";
// import Loginimage from "./Loginimage.svg";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
import InternetChecking from "../../components/Student/Reusablecomponents/Network";
import { useDispatch } from "react-redux";
import { userDetailsData } from "../../components/Redux/Reducers/Logindetails";
// import { LanguageOptions } from "../../components/ReusableComponents/CommonApis";
import { SelectLanguageData } from "../../components/Redux/Reducers/Common/Language";
import axiosInstance from "../../components/ReusableComponents/Axios";
import { CiMail } from "react-icons/ci";
import Loading from "../../components/Student/Reusablecomponents/Loading";

import PLoginImg from "../Assessts/images/Login/PLogin.png";
import { GoArrowRight } from "react-icons/go";
import Triangle from "../Assessts/images/Login/Triangle.png";
import PDesignLogin from "../Assessts/images/Login/PDesignLogin.png";
const PLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputsRef = useRef([]);
  const [LoginDetails, setLoginDetails] = useState({
    LoginId: "",
    Name: "",
  });
  const [Load, SetLoad] = useState(false);
  const [ErrorMessage, setErrors] = useState({});
  const [timer, setTimer] = useState();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [PageNavigation, SetPageNavigation] = useState();
  const handleInputChange = (e) => {
      const { name, value } = e.target;

  setLoginDetails({
    ...LoginDetails,
    [name]: name === "Name" ? value : value.trim(),
  });
    // setLoginDetails({ ...LoginDetails, [e.target.name]:  [e.target.name] === "Name" ? e.target.value :e.target.value.trim() });
  };
  const validationSchema = Yup.object().shape({
    LoginId: Yup.string().email("Invalid email address").required("Email Id is required"),
    Name: Yup.string().required("Name is required"),
  });
  useEffect(() => {
    if (PageNavigation !== 1) return;
    if (timer === 0) {
      // setCanResend(true);
      return;
    }

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer, PageNavigation]);
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const handleSubmit = () => {
    //  localStorage.setItem("EmailId", JSON.stringify(LoginDetails));
    // LanguageOptions(dispatch);
    // const LOptions = [
    //   { display: "English", value: 7629 },
    //   { display: "Hindi", value: 7630 },
    // ];
    // localStorage.setItem("LanguageOptions", JSON.stringify(LOptions));
    // dispatch(
    //   SelectLanguageData({
    //     SLanguage: LOptions?.[0]?.value.toString(),
    //   })
    // );
    validationSchema
      .validate(LoginDetails, { abortEarly: false })
      .then(() => {
        setErrors({});
        if (PageNavigation === 1) {
          VerifyOtp(LoginDetails);
        } else {
          SentOtp(LoginDetails);
        }
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        setErrors(newErrors);
      });
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  const handleChangeOTP = (value, index) => {
    if (!/^\d*$/.test(value)) return; // allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    // if (onChangeOTP) {
    //   onChangeOTP(newOtp.join(""));
    // }

    // move to next input
    if (value && index < otp?.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };
  const handleKeyDownOTP = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };
  const SentOtp = async (values) => {
    SetLoad((prev) => !prev);
    setTimer(0);
    try {
      const res = await axiosInstance.post(`/Auth/send-otp?email=${values["LoginId"]}`);
      if (res.data === "OTP sent successfully")
        
        setTimer(process.env.REACT_APP_Practicetest_OTP_Validation || 120);
      SetPageNavigation(1);
      SetLoad((prev) => !prev);
    }
    catch (err) {
      console.log(err);
      SetLoad((prev) => !prev);
    }
  }
  const VerifyOtp = async (values) => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.post(`/Auth/verify-otp?email=${values["LoginId"]}&otp=${otp.join("")}`);
      if (res.data === "OTP verified successfully") {
        dispatch(userDetailsData({ LoginDetails: LoginDetails }));
        // localStorage.setItem("EmailId", JSON.stringify(LoginDetails));
        localStorage.removeItem("ExamStartTime");
        // window.location.reload();
        navigate("/PracticeTest/TestSelection");
      } else {
        setErrors({OTP:"Invalid OTP"});
      }
      SetLoad((prev) => !prev);
    }
    catch (err) {
      console.log(err);
      setErrors({OTP:"Invalid OTP"});
      SetLoad((prev) => !prev);
    }
  }
  return (
    <>
      <div className="container-fluid mb-3">
        {/* <Row className="login-padding"> */}
        <InternetChecking />

        <div className="dflex alignitems  Practic-MainDiv JCCenter">
          <img src={PLoginImg} alt="Practice Login" className="Practice-Login" />
          <div style={{ position: "relative" }}>
            <div className="dflex flexd-column PLogin-Headings">
              <span>Practice Test</span>
              <span> {PageNavigation === 1 ? "An OTP has been sent to your email. Please enter the OTP." : "Enter your email address to continue your practice test journey."}</span>
            </div>
            <img src={PDesignLogin} alt="Design Login" className="DesignImage" />
            <div className="Card">
              {PageNavigation === 1 ?<>

              <div className="dflex flexd-column gap-2">
                <span>Enter Otp</span>
                <div className="dflex  gap-3">
                {otp.map((digit, index) => (
                  <input key={index} className="OTP-Input"
                    ref={(el) => (inputsRef.current[index] = el)}
                    type="text" maxLength={1} value={digit}
                    onChange={(e) => handleChangeOTP(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDownOTP(e, index)}
                    // onPaste={handlePaste}
                    style={{
                      // width: "45px",
                      // height: "50px",
                      // textAlign: "center",
                      // fontSize: "20px",
                      // border: "1px solid #ccc",
                      // borderRadius: "8px", outline: "none",
                    }}
                  />
                ))}
                
                </div>
                {ErrorMessage?.OTP && <span className="error-message">{ErrorMessage?.OTP}</span>}
                  <div> <b className="text-decoration-underline" style={timer != 0 ? { color: "grey", cursor: "not-allowed" } : { cursor: "pointer" }}
                      onClick={() =>{timer == 0 &&  SentOtp(LoginDetails)}}>Resend</b> OTP in <b>{formatTime(timer)}</b></div>
                </div>
              </> : <>
                <div className="Pinput-container">
                  <span>Enter Name</span>
                  <input type="text" name="Name" placeholder="student"
                    value={LoginDetails.Name} onKeyDown={handleKeyDown} onChange={handleInputChange} />
                </div>
                  {ErrorMessage.Name && ( <span className="error-message">{ErrorMessage.Name}</span> )}
                <div className="Pinput-container mt-3">
                  <span>Email Address</span>
                  <input type="text" name="LoginId" placeholder="student@example.com"
                    value={LoginDetails.LoginId} onKeyDown={handleKeyDown} onChange={handleInputChange} />
                </div>
                {ErrorMessage.LoginId && ( <span className="error-message">{ErrorMessage.LoginId}</span> )}

                </>}
              <button className="Plogin-Button Buttons w-100" onClick={() => handleSubmit()}>
                {PageNavigation === 1 ? "Continue" : "Continue with OTP"} <GoArrowRight />
              </button>
            </div>
            <img src={Triangle} alt="Triangle" className="Triangle" />
          </div>
        </div>
















        {/* <div className="Card Login-queries dflex p-5">
            <Col>
              <div className="Col-Image dflex alignitems JCCenter p-2">
                <img src={Loginimage} alt="Students" style={{ borderRadius: "15px" }} />
              </div>
            </Col>
            <Col className="dflex alignitems JCCenter">
              <div className="Login-details dflex flexd-column alignitems JCCenter mb-3 mt-3">
                <h4>Log in for Practice Test</h4>
                <span className="error-message">
                  {ErrorMessage.length > 0 && ErrorMessage}
                </span>
                {PageNavigation === 1 ?
                  <div className="dflex flexd-column gap-2"> Enter OTP
                    <div className="dflex gap-3">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (inputsRef.current[index] = el)}
                          type="text"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChangeOTP(e.target.value, index)}
                          onKeyDown={(e) => handleKeyDownOTP(e, index)}
                          // onPaste={handlePaste}
                          style={{
                            width: "45px",
                            height: "50px",
                            textAlign: "center",
                            fontSize: "20px",
                            border: "1px solid #ccc",
                            borderRadius: "8px", outline: "none",
                          }}
                        />
                      ))}</div>
                    <div> <b style={timer != 0 ? { color: "grey", cursor: "not-allowed" } : { cursor: "pointer" }}
                      onClick={() => SentOtp(LoginDetails)}>Resend</b> OTP in <b>{formatTime(timer)}</b></div>
                  </div>
                  :
                  <>
                    <div className="input-container">
                      {LoginDetails.LoginId.length === 0 && (
                        <span className="Input-icon dflex">
                          <CiMail fontSize={20} />
                        </span>
                      )}
                      <input
                        type="text"
                        name="LoginId"
                        placeholder="Email Id"
                        value={LoginDetails.LoginId}
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        style={{
                          paddingLeft: LoginDetails.LoginId ? "20px" : "50px",
                        }}
                      />
                    </div>
                    {ErrorMessage.LoginId && (
                      <span className="error-message">{ErrorMessage.LoginId}</span>
                    )} </>

                }

                <br />
                <button className="Buttons Poppins" onClick={() => handleSubmit()}>
                  {PageNavigation === 1 ? "Verify Otp" : "Sent Otp"}
                </button>
              </div>
            </Col>
          </div> */}
        {/* </Row> */}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default PLogin;
